import React from "react"
import Layout from "../components/layout"

export default () => (
<Layout>

  <div class="container desc">
    <div class="row">

        <div class="col-lg-2 col-lg-offset-1">
          <h5>EDUCATION</h5>
        </div>
        <div class="col-lg-6">
          <p><t><u>Columbia University </u></t><br/>
            <li>GPA: 4.16</li>
            <li>Class of 2022, Expected Computer Science Major</li>
            <li>Relevant Coursework: Data Structures, Honors Intro to Comp Sci, Introduction to Computing (Python), Discrete Mathematics, Multivariable Calculus, Principles of Economics</li>
            <li> Clubs and Societies: Columbia Social Entrepreneurship Group, 2018 Entrepreneurship Via Exploration cohort, CU Bhangra, Club Zamana </li>
          </p>
        </div>
        <div class="col-lg-6">
          <p><t><u>St. Luke's School </u></t><br/>
            <li>Valedictorian, Class Treasurer, Honor Council member, 2 years Varsity Soccer, 3 years Varsity Squash</li>
            <li>Cumulative GPA: 4.44; Relevant Test Scores: ACT: 35/36, AP Computer Science: 5/5, AP Calculus BC: 5/5, AP Statistics: 5/5</li>
          </p>
        </div>
    </div>
    </div>

  

  

  <div class="container desc">
    <div class="row">

        <div class="col-lg-2 col-lg-offset-1">
          <h5>WORK</h5>
        </div>
        
        <div class="col-lg-6">
          <p><t><u>Copatient</u> <i>- Intern Software Engineer </i> &nbsp;&nbsp;&nbsp;&nbsp;May 2018 - Aug 2018</t><br/>
          <li>Engineered a pipeline which automates the process of reviewing healthcare documents so that Copatient can make more efficient 
           decisions regarding helping patients get fair claims in the billing process</li>
          <li>Created software using computer vision to classify images of documents and extract key data using the Google Cloud toolkit. This included using Cloud Vision OCR to detect text on documents</li>
          <li>Successfully classified images in >95% of test data, successful meta-data extraction in >80% of test data</li>
          <li> Integrated Natural Language Processing and Machine Learning techniques to obtain more accurate analysis of document. I used annotation tools to create a custom dataset and trained it to recognize medical providers</li>
          </p>
         <p><t><u>Spectator Publishing Company</u> <i>- Associate Developer </i> &nbsp;September 2018 - Present</t><br/>
          <li>Develop and maintain the Columbia Spectator’s (on-campus student publication) website</li>
          <li>Work with journalism and design teams to develop online content with ~2,000,000 sessions per year</li>
          <li>Building an updated, modern website and migrating previous website’s data to this infrastructure</li>
          <li>Underwent intensive, 8-week training program on full stack development in which I became proficient in javascript, HTML/CSS, jquery, React, Node, MongoDB, SQL</li>
          </p>
        </div>
      </div>
    </div>
    
    




  <div class="container desc">
    <div class="row">
        <div class="col-lg-2 col-lg-offset-1">
          <h5>AWARDS</h5>
        </div>

        
        <div class="col-lg-6">
          <p><li>2018 Coca Cola Scholar - <i>Winner of $20,000 Scholarship, selected as one of 150 recipients out of ~90,000 applicants nationwide </i></li>
            <li>National Merit Scholar</li>
          </p>
        </div>
       
    </div>
    </div>


  <div class="container desc">
    <div class="row">
        <div class="col-lg-2 col-lg-offset-1">
          <h5>SKILLS</h5>
        </div>

        
        <div class="col-lg-6">
          <p><t><li>Proficient in Java, Python, Bash scripting, Excel, and full stack development Experience with Spacy NLP Library, Google Cloud 
           Platform, JIRA, and OpenCV, as well.</li>
</t>
          </p>
        </div>
    </div>
    </div>



  </Layout>
)